import React, { useEffect, useState } from "react";
import { fetchBlogs } from "../api/api";
import { Link } from "react-router-dom";

const BlogSection = () => {
    const [blogPosts, setBlogPosts] = useState([]);

    useEffect(() => {
        const getBlogs = async () => {
            try {
                const data = await fetchBlogs();
                if (data.status && data.data) {
                    setBlogPosts(data.data);
                }
            } catch (error) {
                console.error("Error fetching blogs:", error);
            }
        };
        getBlogs();
    }, []);

    return (
        <div className="custom-padding xl-screen-padding pt-80 pb-80 bg-[#f2efed]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {blogPosts.map((post, index) => (
                    <div key={post.id} className="relative">
                        <div className="flex items-center">
                            <img
                                src={post.imageUrl || "https://via.placeholder.com/300"}
                                alt={post.title}
                                className="w-full h-56 object-cover"
                            />
                            {index !== 2 && (
                                <div className="border-l-2 border-gray-400 h-56 mx-4 hidden md:block"></div>
                            )}
                        </div>
                        <div className="p-4">
                            <h3 className="text-lg font-semibold client-text">{post.title}</h3>
                            <Link
                                to={`/blog/${post.slug}`}
                                className="text-[#8f762c] font-bold mt-2 inline-block cursor-pointer"
                            >
                                Read More
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlogSection;